module.exports = __webpack_public_path__ + "img/fruit-ground-cherries-350x184.14e19cf4.jpg";